
      import Weibo from './weibo.vue'
      import type { App, Plugin } from 'vue'

      export const WeiboPlugin: Plugin = {
        install(app: App) {
          app.component('Weibo', Weibo)
        },
      }
      export { Weibo }
      